import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M22 9.476v5.048A7.48 7.48 0 0 1 14.525 22H9.476A7.48 7.48 0 0 1 2 14.524V9.476A7.48 7.48 0 0 1 9.476 2h5.049A7.48 7.48 0 0 1 22 9.476m-2.768.695a5.42 5.42 0 0 0-5.417-5.417h-3.658a5.42 5.42 0 0 0-5.417 5.417v3.658a5.42 5.42 0 0 0 5.417 5.417h3.658a5.42 5.42 0 0 0 5.417-5.417z",
      class: "hidden joe-be:block joe:block qmusic:block",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M22 2H2v20h20z",
      class: "hidden willy:block"
    }, null, -1)
  ])))
}
export default { render: render }